export default {
    pageTitle: '登錄',
    confirm: '確認',
    cancel: '取消',
    loginPage: {
        qsrsjhm: '請輸入手機號碼',
        hqyzm: '獲取驗證碼',
        wyydty: '我已閱讀並同意',
        yhxy: '用戶協議',
        yssm: '隱私聲明',
        dlkf: '内地客服',
        xgkf: '香港客服',
        qydbgxyhxy: '請閱讀並勾選用戶協議、隱私聲明',
        yzmfssb: '驗證碼發送失敗',
        repeatTips: '60s內無須重複獲取驗證碼',
        请输入正确的手机号: '請輸入正確的手機號',
        loginTitle: '登錄/註冊',
        loginDesc: '首次登錄自動註冊財富管理賬號',
        invitationCode: '邀請碼',
        invitationCodeInputHint: '請輸入邀請碼，字母或數字',
    },
    sendPage: {
        srdxyzm: '輸入短信驗證碼',
        yfsdxyzmz: '已發送短訊驗證碼至：',
        cxfs: '重新發送',
        sbdyzm: '收不到驗證碼',
        nkylxkfjxyzmcx: '您可以聯繫客服進行驗證碼查詢。',
        dlkf: '内地客服：',
        xgkf: '香港客服：',
        qsrzqdyzmzsyc: '驗證碼錯誤或失效，請重新輸入',
        zdl: '知道了',
        获取语音验证码: '獲取語音驗證碼',
        '我们将通过电话语音告知您验证码，请留意接听。': '我們將通過電話語音告知您驗證碼，請留意接聽。',
        '如仍无法收到，可': '如仍無法收到，可',
        联系客服: '聯繫客服',
        '语音验证码已发送，请留意接听电话': '語音驗證碼已發送，請留意接聽電話',
        重新获取: '重新獲取',
        输入语音验证码: '輸入語音驗證碼',
        我们正在打电话至: '我們正在打電話至：',
        电话将提供验证码: '，電話將提供驗證碼',
        '语音验证码获取频率过高，请稍后再试': '語音驗證碼獲取頻率過高，請稍後再試',
        联系我们: '聯繫我們',
    },
    Country: {
        qsrdqgjzss: '請輸入地區關鍵字搜索',
        cydq: '常用地區',
    },
    fxhlzq: '復星國際證券',
    已了解: '已了解',
    '系统识别该手机号已绑定交易账户。': '系統識別該手機號已綁定交易賬戶。',
    '为保障您的账户安全，该类型账户暂不支持网页登录，前往': '為保障您的賬戶安全，該類型賬戶暫不支持網頁登入，前往',
    下载或打开星财富APP: '下載或打開星財富APP',
    '，登录您的账户。': '，登入您的賬戶。',
    resetPwdTips1: '系統識別到當前手機號綁定多個交易賬戶。爲保障您的賬戶安全，暫不支持通過網頁重置交易密碼。如有需要，請聯繫我們。',
    resetPwdTips2: '系統識別到當前手機號尚未完成交易賬戶綁定。暫不支持重置交易密碼。如有疑問，請聯繫我們。',
    resetPwdTips3: '系統識別到當前手機號已綁定交易賬戶。該類型賬戶暫不支持重置交易密碼。如有疑問，請聯繫我們。',
    ryLoginTips1: '系统识别到当前手机号绑定多个交易账户，为保障您的账户安全，该类型账户暂不支持站外登录。 如有疑问，请联系我们。',
    ryLoginTips2: '系统识别到当前手机号已绑定交易账户，为保障您的账户安全，该类型账户暂不支持站外登录。 如有疑问，请联系我们。',
    FosunSecuritiesDisclaimer: `復星國際證券提供的所有資管產品均由第三方機構管理，復星國際證券不對產品業績做任何保證。本平台提供數據及信息均來源於公開資料或經外部授權信息的分析和整理，
    復星國際證券發佈此信息的目的在於傳播更多信息，與本平台立場無關，相關表述僅供參考，不代表任何確定性判斷，亦不構成復星國際證券的任何推薦或投資建議。
    對於本平台所發佈的所有產品資料及淨值數據等信息，雖復星國際證券盡力保證數據的準確性、真實性、完整性、有效性、及時性，但投資者仍然須以中國證監會資本市場電子化信息披露平台、
    基金管理人官方網站及其委託的基金估值核算機構發佈的信息為準，並且在做好充分的研究後，以自身研究結果為依據，審慎獨立地作出投資決策。
    本平台所載文章、數據僅供參考，使用前請核實，風險自負。`,
    inviteFriends: '邀請好友',
    inviteList: '邀請明細',
    inviteActivityList: '邀請好友',
    searchInviteActivityList: '邀請好友',
    我的邀请码: '我的邀請碼',
    立即邀请: '立即邀請',
    立即绑定: '立即綁定',
    修改: '修改',
    已绑定: '已綁定',
    '您当前已完成注册，不能绑定注册邀请关系': '您當前已完成註冊，不能綁定註冊邀請關係',
    '您当前已完成开户，不能绑定开户邀请关系': '您當前已完成開戶，不能綁定開戶邀請關係',
    '您当前已完成首次入金，不能绑定入金邀请关系': '您當前已完成首次入金，不能綁定入金邀請關係',
    暂无注册邀请人: '暫無註冊邀請人',
    暂无入金邀请人: '暫無入金邀請人',
    暂无开户邀请人: '暫無開戶邀請人',
    注册邀请人: '註冊邀請人',
    开户邀请人: '開戶邀請人',
    入金邀请人: '入金邀請人',
    绑定邀请人: '綁定邀請人',
    修改邀请人: '修改邀請人',
    '请输入邀请码，字母或数字': '請輸入邀請碼，字母或數字',
    '邀请码为6位数，包含数字或大写字母': '邀請碼為6位數，包含數字或大寫字母',
    暂无您填写的邀请码: '暫無您填寫的邀請碼',
    您的开户邀请人更新为: '您的開戶邀請人更新為',
    您的入金邀请人更新为: '您的入金邀請人更新為',
    星财号: '星財號',
    绑定成功: '綁定成功',
    修改成功: '修改成功',
    绑定失败: '綁定失敗',
    修改失败: '修改失敗',
    邀请码: '邀請碼',
    邀请人更新确认: '邀請人更新確認',
    不能绑定自己为邀请人: '不能綁定自己為邀請人',
    invitee: {
        searchPlaceholder: '請輸入暱稱/星財號/手機號',
        copySuccess: '已複製',
        copyFail: '複製失敗',
        loading: '載入中',
        relationChanged: '邀請關係變更',
        emptyTips: '暫無受邀用戶，快去邀請好友',
        gotIt: '我知道了',
        noMore: '沒有更多了',
        status: {
            registered: '已註冊',
            opened: '已開戶',
            notOpened: '開戶',
            deposited: '已入金',
            qualified: '資產達標',
        },
        profile: {
            myInvites: '我的邀請',
            viewDetail: '查看明細',
            assetQualified: '資產達標',
            assetQualifiedExplain: '資產達標說明',
            assetQualifiedDesc: '資產達標數據於每天 00:00 定時更新。淨入金 = 轉入金額 + 轉入持倉 - 轉出金額 - 轉出持倉。',
        },
    },
    inviteActivity: {
        shareInviteLink: '分享邀請鏈接',
        rule: '活動細則',
        cashRewardTitle1: '最高領8500',
        cashRewardTitle2: '現金券獎勵',
        cashRewardDescription1: '活動期間內邀請達標5個及以內，獎勵200HKD/人；邀請達標6個及以上，最高獎勵500HKD/人',
        cashRewardDescription2: '最高可邀請20人',
        riskTips: '投資涉及風險，優惠受條款約束，詳情請參閱活動細則',
        shareTextTitle: '邀請你來星財富體驗',
        shareTextTitle1: '香港最全投資品類科技券商服務——',
        shareTextPoint1: '1.真正的港美股期權一世免佣',
        shareTextPoint2: '2.港股LV2實時行情',
        shareTextPoint3: '3.多元化資產配置服務',
        shareTextFooter: '現在入資即可領獎，請確保入資前已綁定邀請關係，點擊下方鏈接參與活動：',
        viewMyInvite: '查看我的邀請',
    },
}
